import "@stimulus/polyfills"
import { Application } from 'stimulus'
import FormController from './controllers/FormController'
import HeaderController from './controllers/HeaderController'
import SliderPartnersController from './controllers/SliderPartnersController'

// Initialize stimulus.
const application = Application.start()
application.register('form', FormController)
application.register('header', HeaderController)
application.register('slider-partners', SliderPartnersController)

// Manage load completed event.
window.addEventListener('DOMContentLoaded', () => {
  document.body.classList.add('js')
})